import { Route } from '../../../core/utils/RouteMixins';
import Pages from '../../../config/Pages';
import Lista from './StatusProposta';
import { permissionEnums } from '../../../core/enums/PermissionEnums';

const statusPropostaRoutes = [
    Route(null, Pages.sei.statusProposta.url.list, Lista, [
        permissionEnums.STATUS_PROPOSTA_VISUALIZAR,
    ]),
];

export default statusPropostaRoutes;
